import { actions, paths } from 'src/constants';
import { MAX_PAGE_SIZE } from 'src/constants/common';

export default {
  getGroups: () => ({
    [actions.API_CALL]: {
      types: [
        actions.TREASURE_HUNT_GROUPS_GET_REQUEST,
        actions.TREASURE_HUNT_GROUPS_GET_SUCCESS,
        actions.TREASURE_HUNT_GROUPS_GET_FAILURE,
      ],
      promise: (client) => client.get(paths.api.TREASURE_HUNT_GROUPS),
    },
  }),
  getCollectionsByGroupId: (groupId, page, pageSize = MAX_PAGE_SIZE) => ({
    [actions.API_CALL]: {
      types: [
        actions.TREASURE_HUNT_COLLECTIONS_GET_REQUEST,
        actions.TREASURE_HUNT_COLLECTIONS_GET_SUCCESS,
        actions.TREASURE_HUNT_COLLECTIONS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(paths.api.TREASURE_HUNT_GROUP_ID_COLLECTIONS, groupId),
          {
            params: {
              page,
              pageSize,
            },
          }
        ),
    },
  }),
  getLevelsByCollectionId: (collectionId) => ({
    [actions.API_CALL]: {
      types: [
        actions.TREASURE_HUNT_LEVELS_GET_REQUEST,
        actions.TREASURE_HUNT_LEVELS_GET_SUCCESS,
        actions.TREASURE_HUNT_LEVELS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(
            paths.api.TREASURE_HUNT_COLLECTIONS_ID_LEVELS,
            collectionId
          )
        ),
    },
  }),
};
